import { atom } from "recoil";

export const notificationPermission = atom({
  key: "notificationPermission",
  default: null,
});